function formatZdate(inputDate) {
  // Split the input date string by 'T' to separate date and time
  const dateAndTime = inputDate.split("T");

  // The first part (date) is what we want
  const formattedDate = dateAndTime[0];

  return formattedDate;
}

export default formatZdate;
